import { render, staticRenderFns } from "./AddendumsEditor.vue?vue&type=template&id=75667b27&scoped=true&"
import script from "./AddendumsEditor.vue?vue&type=script&lang=js&"
export * from "./AddendumsEditor.vue?vue&type=script&lang=js&"
import style0 from "./AddendumsEditor.vue?vue&type=style&index=0&id=75667b27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75667b27",
  null
  
)

export default component.exports